// extracted by mini-css-extract-plugin
module.exports = {"bp3-popover-content":"FinanceValuesDetails_bp3-popover-content__1Axqz","bp3-dialog":"FinanceValuesDetails_bp3-dialog__3hJ4j","popover":"FinanceValuesDetails_popover__QPNWW"};